import React from 'react';
import { setIsFilterActiveBonusGames } from '../casino/CasinoActions';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { t } from '../i18n';

interface Props {
    children?: React.ReactNode;
}

const ActiveBonusLink: React.FC<Props> = ({children}) => {
    const dispatch = useDispatch();

    const onClick = () => {
        dispatch(setIsFilterActiveBonusGames(true));
    }

    return (
        <Link to="/casino" onClick={onClick}>{children || t("bonus.terms.go-to-bonus")}</Link>
    );
};

export default ActiveBonusLink;